import { defineStore } from 'pinia'
import { reactive } from 'vue'

export const useModalStore = defineStore('modal', () => {
    const state = reactive({
        showModal: false,
        props: {},
    })

    function openModal(props = {}) {
        state.props = props
        state.showModal = true
    }

    function closeModal() {
        state.showModal = false
        state.props = {}
    }

    function toggleModal() {
        state.showModal = !state.showModal
        if (!state.showModal) {
            state.props = {}
        }
    }

    return {
        state,
        openModal,
        closeModal,
        toggleModal,
    }
})
